<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title details" id="detailsLabel">User Details</h5>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
        id="closeModalButton"
      ></button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-auto">
          <img
            *ngIf="selectedUser?.photo != null"
            src="{{ selectedUser?.photo }}"
            class="user-details-image"
          />
          <img
            *ngIf="selectedUser?.photo == null"
            src="../../../../assets/images/user-not-found-icon.png"
            class="user-details-image"
          />
        </div>
        <div class="col horizontally-center">
          <p class="fs-4">
            {{ selectedUser?.displayName }}
            <fa-icon
              *ngIf="isAdmin"
              [icon]="faPenToSquare"
              class="pen"
              title="Update user"
              (click)="navigateToUpdate(selectedUser?.id)"
            ></fa-icon>
          </p>
          <p>{{ selectedUser?.mail }}</p>
        </div>
      </div>
      <table class="mt-3">
        <tr>
          <th class="fw-normal">Country</th>
          <td *ngIf="selectedUser?.country != null" class="ps-4">
            {{ selectedUser?.country }}
          </td>
          <td *ngIf="selectedUser?.country == null" class="ps-4">unknown</td>
        </tr>
        <tr>
          <th class="fw-normal">City</th>
          <td *ngIf="selectedUser?.city != null" class="ps-4">
            {{ selectedUser?.city }}
          </td>
          <td *ngIf="selectedUser?.city == null" class="ps-4">unknown</td>
        </tr>
        <tr>
          <th class="fw-normal">State</th>
          <td *ngIf="selectedUser?.state != null" class="ps-4">
            {{ selectedUser?.state }}
          </td>
          <td *ngIf="selectedUser?.state == null" class="ps-4">unknown</td>
        </tr>
        <tr>
          <th class="fw-normal">Postal Code</th>
          <td *ngIf="selectedUser?.postalCode != null" class="ps-4">
            {{ selectedUser?.postalCode }}
          </td>
          <td *ngIf="selectedUser?.postalCode == null" class="ps-4">unknown</td>
        </tr>
        <tr>
          <th class="fw-normal">Street Address</th>
          <td *ngIf="selectedUser?.streetAddress != null" class="ps-4">
            {{ selectedUser?.streetAddress }}
          </td>
          <td *ngIf="selectedUser?.streetAddress == null" class="ps-4">
            unknown
          </td>
        </tr>
      </table>
      <div class="row mt-3">
        <div class="col">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-auto">
                  <fa-icon
                    [icon]="faUser"
                    class="fa-2xl gilded-color"
                  ></fa-icon>
                </div>
                <div class="col mt-n10">
                  <p class="fs-6 fw-bold">Account status</p>
                  <p *ngIf="selectedUser?.accountEnabled" class="fs-6">
                    <img
                      src="../../../../assets/images/enabled-icon.png"
                      class="status-image"
                    />
                    Enabled
                  </p>
                  <p *ngIf="!selectedUser?.accountEnabled" class="fs-6">
                    <img
                      src="../../../../assets/images/disabled-icon.png"
                      class="status-image"
                    />
                    Disabled
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <a
            *ngIf="selectedUser?.country != null"
            href="https://www.google.com/maps/place/{{ selectedUser?.country }}"
            target="_blank"
            title="Look on the map"
          >
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-auto">
                    <fa-icon
                      [icon]="faGlobe"
                      class="fa-2xl gilded-color"
                    ></fa-icon>
                  </div>
                  <div class="col mt-n10">
                    <p class="fs-6 fw-bold">User location</p>
                    <p class="fs-6">{{ selectedUser?.country }}</p>
                  </div>
                </div>
              </div>
            </div>
          </a>
          <div *ngIf="selectedUser?.country == null" class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-auto">
                  <fa-icon
                    [icon]="faGlobe"
                    class="fa-2xl gilded-color"
                  ></fa-icon>
                </div>
                <div class="col mt-n10">
                  <p class="fs-6 fw-bold">User location</p>
                  <p class="fs-6">unknown</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
